import { notification } from "antd";
import { useCallback } from "react";
import { useCloseAuditMutation, useDeleteAuditMutation } from "../../apiSlice";
import { getErrorMessage } from "../../../../utils/errors/errors";

type Options = {
  fetchAudits?: () => void;
  fetchAudit?: () => void;
};

export const useCrudAudit = ({ fetchAudits, fetchAudit }: Options = {}) => {
  const [deleteAudit, { isLoading: isDeleting }] = useDeleteAuditMutation();

  const onDelete = useCallback(
    async (id: number) => {
      try {
        await deleteAudit(id).unwrap();
        notification.success({ message: "Audit supprimÃ© avec succÃ¨s." });
        if (fetchAudits) {
          fetchAudits();
        }
      } catch (error) {
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [deleteAudit, fetchAudits],
  );

  /**
   * Close/Validate
   */
  const [closeAudit, { isLoading: isClosing }] = useCloseAuditMutation();

  const onClose = useCallback(
    async (id: number) => {
      try {
        await closeAudit(id).unwrap();
        notification.success({ message: "Audit validÃ© avec succÃ¨s." });
        if (fetchAudit) {
          fetchAudit();
        }
      } catch (error) {
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [closeAudit, fetchAudit],
  );

  return { onDelete, isDeleting, onClose, isClosing };
};
